import * as React from 'react';
import { classes, st } from './Ribbon.st.css';
import { RibbonShape } from './types';
import { Video } from '@wix/wix-ui-icons-common/on-stage';
import { BlogLarge } from '@wix/wix-ui-icons-common/on-stage/system';
/** A ribbon is a visual indicator that helps users quickly locate an item that has an important distinctive attribute within a list of otherwise  similar objects */
export class Ribbon extends React.Component {
    render() {
        const { className, children, shape } = this.props;
        return (React.createElement("div", { className: st(classes.root, { square: shape === RibbonShape.Square }, className), "data-hook": this.props['data-hook'] },
            className === '1' && React.createElement(Video, null),
            className === '2' && React.createElement(BlogLarge, null),
            children));
    }
}
Ribbon.displayName = 'Ribbon';
//# sourceMappingURL=Ribbon.js.map